<script setup>
import HistoryView from "@/shared/ui/history/HistoryView.vue";

defineProps({
  form: {
    type: Object,
    default: () => null,
  },
});
</script>

<template>
  <HistoryView
    :entity="form"
    id-field="id"
    service="TEMPLATE-GENERATE"
    api-path="/api/transactions"
  />
</template>
